import { c as _c } from "react/compiler-runtime";
import { Button } from "@mui/material";
import { colorDisabledDisabled } from "@/app/(styles)/variables";
import { textPrimaryOnColorPrimary } from "@/app/(styles)/variables";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CheckOutlinedIcon from "@mui/icons-material/CheckOutlined";
export const QuesSheetFooter = t0 => {
  const $ = _c(14);
  const {
    handleNext,
    handlePrevious,
    handleSubmit,
    answers,
    currentQuestionData,
    isFirstScreen,
    isLastScreen
  } = t0;
  let t1;
  if ($[0] !== answers || $[1] !== currentQuestionData) {
    t1 = () => {
      const answer = answers[currentQuestionData?.id];
      if (!answer) {
        return false;
      }
      if (currentQuestionData.type === "checkbox") {
        const values = answer.values || answer;
        return Object.keys(values).length > 0;
      }
      return answer.value !== undefined || answer !== undefined;
    };
    $[0] = answers;
    $[1] = currentQuestionData;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isAnswerSelected = t1;
  const isNextDisabled = !isAnswerSelected();
  let t2;
  if ($[3] !== handlePrevious || $[4] !== isFirstScreen) {
    t2 = !isFirstScreen && <div className="w-full gap-3 flex  "><Button onClick={handlePrevious} variant="outlined" className=" flex-1  bg-[--colorSurfaceSurface] !text-[--textSecondarySecondary] !border-[--colorSecondarySecondary] px-2 py-5 !rounded-full cursor-pointer    " startIcon={<ArrowBackIcon />}>Prev</Button></div>;
    $[3] = handlePrevious;
    $[4] = isFirstScreen;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== handleNext || $[7] !== handleSubmit || $[8] !== isLastScreen || $[9] !== isNextDisabled) {
    t3 = <div className="w-full gap-3 flex ">{isLastScreen ? <Button onClick={handleSubmit} disabled={isNextDisabled} variant="contained" className=" flex-1  bg-[--colorSurfaceSurface] text-[--textPrimaryOnColorPrimary] px-2 py-5 !rounded-full cursor-pointer    " sx={{
        "&.Mui-disabled": {
          backgroundColor: colorDisabledDisabled,
          color: textPrimaryOnColorPrimary
        }
      }} startIcon={<CheckOutlinedIcon />}>Submit</Button> : <Button onClick={handleNext} disabled={isNextDisabled} variant="contained" className=" flex-1  bg-[--colorSurfaceSurface] text-[--textPrimaryOnColorPrimary] px-2 py-5 !rounded-full cursor-pointer    " sx={{
        "&.Mui-disabled": {
          backgroundColor: colorDisabledDisabled,
          color: textPrimaryOnColorPrimary
        }
      }} startIcon={<ArrowForwardOutlinedIcon />}>Next</Button>}</div>;
    $[6] = handleNext;
    $[7] = handleSubmit;
    $[8] = isLastScreen;
    $[9] = isNextDisabled;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t2 || $[12] !== t3) {
    t4 = <div className="flex justify-between bg-[--colorSurfaceSurface] p-4 gap-3 ">{t2}{t3}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
};